

import React, { PureComponent } from 'react';
import { StyleSheet } from 'react-native';
import PropTypes from 'prop-types';
import { createContainer } from '@dbk-legacy/muster/react';
import { Info2, Close } from '@dbk/ui-icons';
import Button, { IconButton } from '@dbk/ui-buttons';
import Text,{H1} from '@dbk/ui-text';
import moment from 'moment';
import InverseProvider from '@dbk/ui-inverse';
import { DatePicker, Utils } from '@dbk/ui-datepicker';
import Modal from '@dbk/ui-modal';
import Popover from '@dbk/ui-popover';
// import Dropdown from '../../../../../../../src/components/common/dropdown';
import Dropdown from '@dbk/ui-dropdowns';
import { DATE_RANGE } from '../../constants';
import { format } from 'date-fns';
import { PORTFOLIO_RELIDTYPE } from '../../../../../../../src/constants';
import { ALL_PORTFOLIO_ID, RIGHT_MENU_ICON_STYLE } from '../../../../constants';
import { LoadingCircle } from '../../../../../../../src/components/common/loading';
import ErrorIcon from '../../../../../../../src/components/common/icons/error-icon';
import styles from './report-adhoc-statement.styles';
import { PALETTE } from '../../../../../../../src/constants';

class ReportAdhocStatement extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      accountPortfolio:'',
      statementType:'',
      daterange: {
        // from: this.props.customDateRange.from ? moment(this.props.customDateRange.from).toDate() : null,
        // to: this.props.customDateRange.to ? moment(this.props.customDateRange.to).toDate() : null
        from: null,
        to:null

      },
      statementTypeList:[],
      accountPortfolioList:[],
      isAccount: null
    };
  }

  /**
   * function: componentWillMount will be used to load the documents
   */
  componentWillMount() {
  //  (async () =>  await this.props.reports.getStatementTypes())();
    
    // filter account portfolio list on the basis of PF IDs and BP IDs
    let accountPortfolioList = this.props.app.user.portfoliosData.filter(portfolio => {
      return portfolio.relIdType === PORTFOLIO_RELIDTYPE.PORTFOLIOS || portfolio.relIdType === PORTFOLIO_RELIDTYPE.BP  
    })

    // add label and value key in acountportfoliolist to for dbk-ui-dropdown
    this.setState({accountPortfolioList: accountPortfolioList.map(res => {
      return {
        label:this.getPortfolioDisplay(res, true),
        value:res.title,
        ...res
      }
    })}, this.initializeAccountSelection)
    
  }

  componentDidUpdate(){
    if(document.querySelector('.cancelOrderfocus')){
      document.querySelector('.cancelOrderfocus').focus();
    }
    if(this.state.daterange.from && this.state.daterange.to){
        setTimeout(() => {
          if(document.querySelector('#applyBtnFocus')){
              document.querySelector('#applyBtnFocus').focus();
            }
        }, 100);
    }
    if(document.querySelector('.orderReport h3')){
      document.querySelector('.orderReport h3').focus();
    }
  }

  /**
   *  callback function to initalise account if selected from parent coomponent
   */
  initializeAccountSelection = () =>{
    const selectedPortfolio =
    this.props.app.user.selectedPortfolioData || this.props.app.user.selectedPortfolio;
    if (selectedPortfolio.relIdType === PORTFOLIO_RELIDTYPE.PORTFOLIOS ||selectedPortfolio.relIdType === PORTFOLIO_RELIDTYPE.BP){
      console.log({accountId: selectedPortfolio.title,relIdType: selectedPortfolio.relIdType});
    
      this.handleAccountPortfolioChange(selectedPortfolio.title)
    }
  }

  getPortfolioDisplay(portfolio, renderList) {

    const { i18n: { messages }} = this.props;

    let portfolioRelId = '';

    if (
      this.props.rsa.rsaAuthorised === true ||
      this.props.vascoauthentication.vascoAuthorised === true
    ) {
      portfolioRelId =
        portfolio.relId !== null ? portfolio.relId : portfolio.title;
    } else if (portfolio.relId === null) {
      portfolioRelId =
        portfolio.title.substr(0, 1) + 'XXXXX' + portfolio.title.slice(6);
    } else {
      portfolioRelId =
        portfolio.relId.substr(0, 1) + 'XXXXX' + portfolio.relId.slice(6);
    }
    if (portfolio.id === ALL_PORTFOLIO_ID)
      return messages["app.chedelivery.reports.allPortfolioTitle"];
    if(portfolio.relIdType === PORTFOLIO_RELIDTYPE.ALL_PORTFOLIOS)
      return messages["app.dashboard.selector.allAccounts"]; // WMCE-4862 BP CONSOLIDATION

    if(portfolio.relIdType === PORTFOLIO_RELIDTYPE.PORTFOLIOS){
      let pfLabel= '';
      if(renderList){
        pfLabel =  `${portfolioRelId} - ${portfolio.referenceCurrency.toUpperCase()} (${portfolio.pfType} ${messages["app.dashboard.summaryData.portfolioId.label"]})`;
      }
      else {
        pfLabel = `${portfolioRelId} - ${portfolio.referenceCurrency.toUpperCase()}`;
      }
      return pfLabel;
    }

    if(portfolio.relIdType === PORTFOLIO_RELIDTYPE.CONSOLIDATED){
      let pfLabel= '';
      if(renderList){
        pfLabel =  `${portfolioRelId} (${messages["app.header.wigdet.consolidated.label"]})`;
      }
      else {
        pfLabel = `${portfolioRelId}`;
      }
      return pfLabel;
    }
    
    return `${portfolio.relIdName ? portfolio.relIdName : portfolioRelId} - ${portfolio.referenceCurrency.toUpperCase()}`;
  }

  handleAccountPortfolioChange = (accountPortfolio)=> {

    let statementType = this.props.reports.adhoc.statementTypes;

    //get reIdType of account/portfolio    // accountPortfolio -  check added as it breaks when you select "Select" option from dropdown
    let accountPortfolioRelIdType = accountPortfolio && this.state.accountPortfolioList.length > 0 && this.state.accountPortfolioList.filter(res => res.title === accountPortfolio)[0].relIdType
    
    let filteredStatementTypeList = statementType.filter(res => res.relIdType === accountPortfolioRelIdType);

    // add label and value key in filteredStatementTypeList to for dbk-ui-dropdown
    filteredStatementTypeList = filteredStatementTypeList.map(res =>{
      return {
        label: res.description,
        value: res
      }
    })
    
    // set account portfolio, filter statementType and reset statementType and daterange
    this.setState({
      accountPortfolio: accountPortfolio, 
      statementTypeList: filteredStatementTypeList, 
      statementType:'',
      daterange : {
        from : null,
        to: null
      },
      isAccount: accountPortfolioRelIdType === PORTFOLIO_RELIDTYPE.BP ? true : false
    })
    
  }

  onStatementTypeChanged = (statementType) => {

    // set account type and reset daterange 
    this.setState({
      statementType: statementType, 
      daterange : {
        from : null,
        to: null
    }})
  }


  customFooter = () => {
    const { i18n: { messages } } = this.props;
    return <InverseProvider inverse style={{ borderBottom: "1px solid #535b61", width: "100%", height: "60px", backgroundColor: '#12213c', paddingTop: "15px" ,display: "flex", justifyContent:"space-between",  paddingRight:"6px" }} >
        <div className='datepicker-footer-txt'>
        <Text style={{ padding: "5px" }}>{messages['app.chedelivery.reports.customReports.today']}{moment().format('DD-MMM-YYYY')}</Text>
      </div>
        <div className='datepicker-footer-btn'>
        <Button tertiary
                    onClick={() => this.onCancel()}
                >{messages['app.chedelivery.reports.customReports.cancelButton']}</Button>

            <Button
            id="applyBtnFocus"
            disabled={!(this.state.daterange.from && this.state.daterange.to)}
                onClick={() => this.onApplyDateChange()}
            >{messages['app.chedelivery.reports.apply']}</Button>
        </div>
    </InverseProvider>
  }

  onApplyDateChange = () => {
    this.datepickerRef.close();
  }

  onCancel = () => {
    this.datepickerRef.close();
    this.setState({
      daterange : {
        from : null,
        to: null
      }
    })
  }

  /**
   * 
   * function to check if all the fields are selected and generate is to be disabled
   * @returns false if valid
   */
  getIsDisabled = () => {
    if (this.state.accountPortfolio && this.state.statementType && this.state.daterange.from && this.state.daterange.to) {
      return false
    }
    return true
  }

  generateReport = () => {

    const dataForAdhoc ={
      accountId:this.state.accountPortfolio,
      reportTypeId: this.state.statementType.reportTypeId,
      reportDurationFrom: format(new Date(this.state.daterange.from), 'dd-MM-yyyy'),
      reportDurationTo: format(new Date(this.state.daterange.to), 'dd-MM-yyyy'),
      isAccount: this.state.isAccount
    }
    this.props.reports.generateAdhocReport(dataForAdhoc);    
  }
  onChangeDateRange = (range)=> {    
    this.setState({
      daterange:{
        ...range
        }
    });
  }
  onCancelReportGen = () =>{
    const { reports: { adhoc: { setShowCancelModal } } } = this.props;
    setShowCancelModal(true);
  }

  componentWillUnmount() {
    this.props.reports.setErrMsg(null);

  }

  goToReports = () => {
    const { reports: { setErrMsg}, goBack } = this.props;
    setErrMsg(null);
    goBack();
  }

  closeModal = () => {
    const { reports: { adhoc: { setShowCancelModal } } } = this.props;
    setShowCancelModal(false);
  }

  orderReportCancelModal = () => {
    const { i18n: { messages } } = this.props;
    return (
      <Modal
        isActive
        hideCloseButton
        header={messages['app.warning.text']}
        onClose={this.closeModal}
        content={
          <div className="padding-20">
            <Text tabIndex={0} className="cancelOrderfocus">{messages['app.reports.orderReport.cancelModalMsg']}</Text>
            <div style={StyleSheet.flatten(styles.modalBtnBlock)}>         
              <div className="payment-btn" style={StyleSheet.flatten(styles.btnSize)} >
                <Button             
                  size="large"
                  tertiary
                  fullWidth
                  margin
                  onPress = {this.closeModal}
                >
                  {messages['app.payments.summary.cancel']}
                </Button>
              </div>
              <div className="payment-btn" style={StyleSheet.flatten(styles.btnSize)} >
                <Button
                  size="large"
                  fullWidth
                  onPress={() => { this.goToReports(); this.closeModal() }}
                >
                {messages['app.trade.label.proceed']}
                </Button>
              </div>
            </div>
          </div>
        }
      />
    )
  }

  render() {
    const { i18n: { messages }, reports:{ adhoc: {errorMessage, showCancelModal }, showSpinner}, portfolio : {overallMarketValue: {asOfDate}}} = this.props;

    
    
    // show loading spinner
    if (showSpinner){
      return (<div>
        <LoadingCircle />
      </div>)
    }

    const informationText=messages["app.reports.orderReport.popoverContentMsg1"] + "  " + messages["app.reports.orderReport.popoverContentMsg2"] + "  " + messages["app.reports.orderReport.popoverContentMsg3"];
      
    return (
      <React.Fragment>
        {/* error block start */}
        <div className='orderReport '>
          {errorMessage && <div className="orderReport__errorContainer">
            <div className='orderReport__errorContainer--header'>
              <ErrorIcon width={30} height={30} />
              <h3 tabIndex={0}> {messages['app.payments.confirmation.error']}</h3>
                <IconButton
                  className="closeIconButton"
                  onClick={() => this.props.reports.setErrMsg(null)}>
                  <div aria-label={messages['app.chedelivery.reports.close']}>
                    <Close color={'#999'} height={30} width={30} />
                  </div>
                </IconButton>
              
            </div>
            
            <div tabIndex={0} className='orderReport__errorContainer--subheader'>
              <p>{errorMessage}</p>
            </div>
          </div>}
        </div>
        {/* error block end */}
      
        <div className='orderReport'>
          <div className='orderReport__header'>
            <H1 className={"orderReport__heading-title"} tabIndex={0}>{messages['app.reports.orderReport.headerLabel']}</H1>
              <Popover
                  mode="popup"
                  orientation="right"
                  showOnHover
                  popOverClassName="total-mkt-val-popover"
                  arrowColor={PALETTE.secondaryActive}
                  content={
                    <div>
                      <p>{messages["app.reports.orderReport.popoverContentMsg1"]}</p>
                      <p>{messages["app.reports.orderReport.popoverContentMsg2"]}</p>
                      <p>{messages["app.reports.orderReport.popoverContentMsg3"]}</p>
                    </div>}
                >
                  <div aria-label={messages['app.orderReport.infoIcon'] + "  " + informationText} className='margin-left-5'>
                    <Info2 className="cash-total-mkt-val-Qmark" color={PALETTE.fordGray} height={RIGHT_MENU_ICON_STYLE.height} width={RIGHT_MENU_ICON_STYLE.width}/>
                  </div>
              </Popover>
          </div>
          <div className='orderReport__subheader'>
            <Text size={"large"} tabIndex={0}>
              {messages['app.reports.orderReport.subheaderLabel']}
            </Text>
          </div>


          <div className='contentContainer'>
            <div className='orderReport__content'>
                <div className='orderReport__content__field'>
                  <div className="orderReport__content__field--label" tabIndex={0}>
                    <Text secondary> {messages['app.reports.orderReport.accountPortfolioLabel']} </Text>
                  </div>
                  
                  <div className="orderReport__content__field--dropdown" aria-label={messages['app.reports.accountPortfolioDropdown']}>
                    <Dropdown
                      testID="ddn-filterModal-documentType-test"
                      size='large'
                      title={messages['app.reports.accountPortfolioDropdown']} // title props added because of IBM accessibility check issue
                      fullWidth
                      required
                      selected={this.state.accountPortfolio}
                      options={this.state.accountPortfolioList}
                      defaultLabel={messages['app.reports.orderReport.accountPortfolioPlaceholder']}
                      onChange={option => {
                        this.handleAccountPortfolioChange(option)
                      }}
                      isPortfolio={true}
                    />
                    </div>
                </div>
                <div className='orderReport__content__field'>
                  <div className="orderReport__content__field--label" tabIndex={0}>
                    <Text secondary>  {messages['app.reports.orderReport.statementLabel']}</Text>
                  </div>
                  
                  <div className="orderReport__content__field--dropdown" aria-label={messages['app.reports.orderReport.statementPlaceholder']}>
                    <Dropdown
                      testID="ddn-filterModal-documentType-test"
                      size='large'
                      title={messages['app.reports.orderReport.statementPlaceholder']}
                      fullWidth
                      required
                      selected={this.state.statementType}
                      options={this.state.statementTypeList.length>0 &&this.state.statementTypeList}
                      defaultLabel={messages['app.reports.orderReport.statementPlaceholder']}
                      onChange={option => {
                        this.onStatementTypeChanged(option)

                      }}
                    />
                    </div>
                </div>
                <div className='orderReport__content__field'>
                  <div className="orderReport__content__field--label" tabIndex={0}>
                    <Text secondary>  {messages['app.chedelivery.reports.dateRangetab']}</Text>
                  </div>
                  <div className="orderReport__content__field--dropdown input-container">
                    <DatePicker
                      ref={(ref) => this.datepickerRef = ref}
                      showOutsideMonthDays={false}
                      tetherProps={{attachment : "top center", targetAttachment : "right center"}}
                      enableYearNavigation
                      enableRangeSelection
                      fullWidth
                      required
                      onChange={this.onChangeDateRange}
                      value={this.state.daterange}
                      startDate={moment().startOf('year').subtract(5, 'y').toDate()}
                      endDate={moment(asOfDate).toDate()}
                      inputDateFormat={'dd MMM yyyy'}
                      rangeSeparator={' - '}
                      selectionStart={this.state.daterange.from}
                      selectionEnd={this.state.daterange.to}
                      renderFooter={() => this.customFooter()}
                    />
                    </div>
                </div>
            </div>
            <div className='orderReport__content'>
                <Text size="large" tabIndex={0} className="margin-top-10 margin-bottom-20">
                {messages['app.reports.orderReport.disclaimerText1']}
                </Text>
                <Text size="large" tabIndex={0} className="margin-bottom-20">
                {messages['app.reports.orderReport.disclaimerText2']}
                </Text>
                <Text size="large" tabIndex={0}>
                {messages['app.reports.orderReport.disclaimerText3']}
                </Text>
            </div>
          </div>

          <div className='orderReport__actionButtons'>
            
            <div className='orderReport__actionButtons--position'>
            <Button
                size='large'
                tertiary
                fullWidth={false}
                onClick={ this.onCancelReportGen}>
                  {messages['app.chedelivery.reports.customReports.cancelButton']}
              </Button>

              <Button
                size='large'
                disabled = {this.getIsDisabled()}
                onClick={this.generateReport}
                fullWidth={false}>
                  {messages['app.reports.orderReport.generate']}
              </Button>
            </div>
          </div>
        </div>
        { showCancelModal && this.orderReportCancelModal() }
      </React.Fragment>
    );
  }
 
}

export default createContainer({
  $renderLoading: () => <LoadingCircle />,
  $queries: {
    
    changePage: { $call: 'ui.history.push' },
    i18n: {
      messages: true,
    },
    app: {
      user: {
        portfolios: true,
        selectedPortfolioData: true,
        portfoliosData:true,
        selectedPortfolio: true,
      },
    },
    rsa: {
      rsaAuthorised: true,
      onChangePage: { $call: 'changePage' },
    },
    vascoauthentication: {
      vascoAuthorised: true,
    },
    reports: {
      showSpinner: true,
      generateAdhocReport: {
        $call: 'generateAdhocReport'
      },
      setErrMsg: {$set: 'adhoc.errorMessage'},
      adhoc:{
        statementTypes: true,
        errorMessage: true,
        showCancelModal: true,
        setShowCancelModal: { $set: 'showCancelModal' }
      },
      getStatementTypes: {$call: 'getStatementTypes'},
    },
    portfolio : {overallMarketValue: {asOfDate: true }},
    goBack: { $call: 'ui.history.goBack' },
  },
})(ReportAdhocStatement);
